import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CronosFilePage } from './cronos-file';

@NgModule({
  declarations: [
    CronosFilePage,
  ],
  imports: [
    IonicPageModule.forChild(CronosFilePage),
  ],
})
export class CronosFilePageModule {}



// WEBPACK FOOTER //
// ./src/pages/cronos-file/cronos-file.module.ts